<template>
  <div class="pc-skeleton-sign-up pc-skeleton-sign-up--payment">
    <div class="pc-sign-up-register__content-col col-md-12 col-lg-8">
        <div class="pc-sign-up-register__plan">
            <div class="container p-0" >
              <div class="pc-skeleton-sign-up__input--two row">
                <div class="pc-skeleton-sign-up__input col-6">
                  <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="100px" height="16px" />
                  <AnimatedPlaceholder width="100%" height="60px" />
                </div>
                <div class="pc-skeleton-sign-up__input col-6">
                  <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="100px" height="16px" />
                  <AnimatedPlaceholder width="100%" height="60px" />
                </div>
              </div>
            </div>
          </div>
      </div>
 </div>
</template>

<script >
import AnimatedPlaceholder from '@/components/global/animators/AnimatedPlaceholder';

export default {
    components: {
      AnimatedPlaceholder
    }
}
</script>
  
<style>


</style>